function append<T extends { id: string }>(list: T[], item: T): T[] {
  return [...list, item];
}

export { append };
